// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"doctor-registration_wrapper__1b-nJ","tableWrapper":"doctor-registration_tableWrapper__23MNJ"};